import storage from 'storejs';
import store from '../store';
import Layout from '../pages/index';
/* eslint-disable */
const _import = require('../router/_import_' + process.env.NODE_ENV);

export function getUrlParam(name) {
    const parmsStr = window.location.search.substring(1);
    const parmsArr = parmsStr.split('&');
    const parms = {};
    for (let i = 0; i < parmsArr.length; i++) {
        parms[parmsArr[i].split('=')[0]] = parmsArr[i].split('=')[1];
    }
    return parms[name];
}

export function parseTime(time) {
    const dateTime = typeof time === 'object' ? time : new Date(time);
    const year = dateTime.getFullYear();
    const month = dateTime.getMonth() + 1 < 10 ? `0${dateTime.getMonth() + 1}` : dateTime.getMonth() + 1;
    const day = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate();
    const hour = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
    const minute = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();
    const second = dateTime.getSeconds() < 10 ? `0${dateTime.getSeconds()}` : dateTime.getSeconds();
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export function getToken(key) {
    return storage.get(key);
    // storage(key)
}

export function setToken(key, value) {
    storage.set(key, value);
    // storage(key, value)
}

export function removeToken(key) {
    storage.remove(key);
    // storage.remove(key)
    // storage.clear()
}

export function getMenu(menuList) {
    menuList.forEach((item) => {
        if (item.isList === 'Y') {
            store.commit('getMenuArr', { menu: item.path });
        }
        if (item.children && item.children.length !== 0) {
            getMenu(item.children);
        }
    });
}

export function getCache(menuList) {
    menuList.forEach((item) => {
        if (item.isList === 'Y' && item.isCache === 'Y') {
            store.commit('getCacheArr', { menu: item.path });
        }
        if (item.children && item.children.length !== 0) {
            getCache(item.children);
        }
    });
}

/**
 * 函数防抖
 */
export function debounce(fn, delay) {
    console.log(fn, delay)
    // 记录上一次的延时器
    var timer = null;
    var delay = delay || 200;
    return function() {
        var args = arguments;
        var that = this;
        // 清除上一次延时器
        clearTimeout(timer)
            timer = setTimeout(function() {
            fn.apply(that,args)
        }, delay);
    }
}
/**
 * 函数节流
 */
export function throttle(func, wait) {
    let timeout; // 定义一个计时器变量，用于限制函数调用频率
    return function (...args) { // 返回一个包装后的函数
        const context = this; // 保存函数执行上下文对象
        if (!timeout) { // 如果计时器不存在
            func.apply(context, args); // 执行函数
            timeout = setTimeout(() => {
                timeout = null; // 清空计时器变量
            }, wait); // 创建计时器，在指定时间后重置计时器变量
        }
    };
  }
   

// 将后台传来的路由转化为可识别的格式
export function getRouters(routers, newRouter) {
    for (let i = 0; i < routers.length; i++) {
        if (routers[i]) {
            if (routers[i].children == null || routers[i].children === '') {
                delete routers[i].children
            }
            routers[i].meta = {
                isList: routers[i].isList,
                isCache: routers[i].isCache,
                hidden: routers[i].hidden,
                title: routers[i].name,
                icon: routers[i].icon,
                forbidden: routers[i].forbidden,
                menuId: routers[i].menuId,
                type: routers[i].type,
                redirect: routers[i].redirect,
            }
            if (routers[i].type === 1) {
                delete routers[i].redirect
            }
            delete routers[i].isList
            delete routers[i].isCache
            delete routers[i].hidden
            delete routers[i].icon
            delete routers[i].forbidden
            delete routers[i].menuId
            delete routers[i].type
            delete routers[i].orderNum
            delete routers[i].parentId
            delete routers[i].parentName
            if (routers[i].component === 'Layout') {
                routers[i].component = Layout
            } else if (routers[i].component !== '') {
                try {
                    routers[i].component = _import(routers[i].component)
                } catch (error) {
                    delete routers[i].component
                }
            } else {
                delete routers[i].component
            }
            if (routers[i].children && routers[i].children.length > 0) {
                getRouters(routers[i].children, newRouter)
            }
        }
    }
    return routers
}


// WEBPACK FOOTER //
// ./src/utils/index.js